import React, { useState } from 'react'
import Topheader from '../Topheader'
import Mainmenu from '../Mainmenu'
import CoursesNavbar from '../CoursesNabbar'
import Couses from '../Couses'
import Footer from '../Footer'
import ChapterBox from '../class 10/ChapterBox'
import Noteswritten from '../Noteswritten'

export default function Computer9() {
  const [selectedPdf, setSelectedPdf] = useState(null);

  const chapters = [
    { no: 1, name: "Computer Networking , Telecommunication, Internet and Services", pdflink:"https://drive.google.com/file/d/1C0Uhm8DqZuZ3hiyNAz5VqnyRLtB2p8uK/preview"},
    { no: 2, name: "Ethical and social issues", pdflink:"" },
    { no: 3, name: "Computer Security", pdflink:"" },
    { no: 4, name: "E-commerce", pdflink:"" },
    { no: 5, name: "Contemporary Technology", pdflink:"" },
    { no: 6, name: "Number System", pdflink:"" },
    { no: 7, name: "Database Management System : Microsoft Access", pdflink:"" },
    { no: 8, name: "Control Statements and Library Function In QBASIC", pdflink:"" },
    { no: 9, name: "Modular Programming in QBASIC", pdflink:"" },
    { no: 10, name: "File Handling in QBASIC", pdflink:"" },
    { no: 11, name: "C Programming", pdflink:"" },
  ];

  return (
    <>
      {/* Header Section */}
      <div className='bg-slate-300 mt-5 pb-3 lg:pb-3 shadow-sm'>
        <Noteswritten/>
      </div>

      <div className='mt-3'>
        <CoursesNavbar/>
      </div>

      {/* Chapter List */}
      <div className="flex justify-center flex-wrap mt-5 gap-4">
        {chapters.map((chapter) => (
          <div
            key={chapter.no}
            onClick={() => setSelectedPdf(chapter.pdflink)}
            className="cursor-pointer flex-1 min-w-[250px] max-w-[280px] flex"
          >
            <ChapterBox
              chapterNo={chapter.no}
              chapterName={chapter.name}
            />
          </div>
        ))}
      </div>

      {/* PDF Viewer */}
      {selectedPdf && (
        <div className="mt-5 flex flex-col items-center px-2">
          {/* Close Button */}
          <button 
            onClick={() => setSelectedPdf(null)} 
            className="mb-3 px-4 py-2 bg-red-500 text-white rounded-lg shadow hover:bg-red-600 transition"
          >
            Close PDF
          </button>

          {/* Responsive PDF iframe */}
          <div className="w-full md:w-4/5 h-[700px] md:h-[700px]">
            <iframe
              src={selectedPdf}
              className="w-full md:w-full h-full border border-gray-300 rounded-lg shadow-md bg-white"
              allow="autoplay"
              title="PDF Viewer"
            ></iframe>
          </div>
        </div>
      )}
            <div className='mt-[120px]'><Footer></Footer></div>

    </>
  )
}
